import { render, staticRenderFns } from "./SubjectsSyncTable.vue?vue&type=template&id=39a7b85d"
import script from "./SubjectsSyncTable.vue?vue&type=script&lang=js"
export * from "./SubjectsSyncTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports